<app-titled-page heading="Repuestos">
  <router-outlet></router-outlet>
</app-titled-page>
